<template>
    <span class="mb-1">
        <badge v-if="currentPaymentStatus === PAYMENT_STATUSES.PAYMENT_PROCESSING" type="primary">
            <i class="fa fa-dollar mr-1"></i>
            Payment Processing
        </badge>
        <badge v-if="currentPaymentStatus === PAYMENT_STATUSES.PAYMENT_DELAYED" type="warning">
            <i class="fa fa-dollar mr-1"></i>
            Payment Delayed
        </badge>
        <badge v-if="currentPaymentStatus === PAYMENT_STATUSES.ACTION_NEEDED" type="danger">
            <i class="fa fa-dollar mr-1"></i>
            Action Needed
        </badge>
        <badge v-if="currentPaymentStatus === PAYMENT_STATUSES.PAYMENT_COMPLETED" type="success">
            <i class="fa fa-dollar mr-1"></i>
            Payment Completed
        </badge>
    </span>
</template>
<script>
import { PAYMENT_STATUSES } from '@/utils/constants'
import { Badge } from '@/components/UIComponents'
export default {
    components: {
        Badge
    },
    props: {
        currentPaymentStatus: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            PAYMENT_STATUSES
        }
    }
}
</script>

<style lang="scss" scoped>
.p-badge {
    margin-right: 0.25rem;
}
</style>
